import { z } from "zod";

const amount = z.number().finite().nonnegative();
const schema = z.object({
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  balance: amount,
  unpaidKnown: amount,
  fenceAllocation: amount,
  monthlyConfirmed: amount,
  monthlyPossible: amount,
  potentialSale: amount,
  optionalScaffold: amount,
  reserve: amount.nullable(),
  monthlyStart: z.string().nullable(),
});
export type CashPosition = z.infer<typeof schema>;

export function parseCashPosition(
  description?: string | null,
): CashPosition | null {
  try {
    const data = JSON.parse(description || "{}");
    const parsed = schema.safeParse(data.cashPosition);
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}

export function availableCash(position: CashPosition): number {
  // Il saldo è già netto delle spese passate: nessuna seconda sottrazione.
  return (
    position.balance -
    position.unpaidKnown -
    position.fenceAllocation -
    (position.reserve ?? 0)
  );
}
